import { render } from "./aiAnalyze.vue?vue&type=template&id=66b5beef&scoped=true"
import script from "./aiAnalyze.vue?vue&type=script&lang=js"
export * from "./aiAnalyze.vue?vue&type=script&lang=js"

import "./aiAnalyze.vue?vue&type=style&index=0&id=66b5beef&scoped=true&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b5beef"]])

export default __exports__